export const GET_PAYMENTS = 'GET_PAYMENTS';// 获取圈子列表

export const GET_MONEY = 'GET_MONEY';// 获取圈子列表